var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZipCodeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.667 4.9987H10.0003L8.82533 3.8237C8.50866 3.50703 8.08366 3.33203 7.64199 3.33203H3.33366C2.41699 3.33203 1.67533 4.08203 1.67533 4.9987L1.66699 14.9987C1.66699 15.9154 2.41699 16.6654 3.33366 16.6654H16.667C17.5837 16.6654 18.3337 15.9154 18.3337 14.9987V6.66536C18.3337 5.7487 17.5837 4.9987 16.667 4.9987ZM15.0003 9.9987H13.3337V11.6654H15.0003V13.332H13.3337V14.9987H11.667V13.332H13.3337V11.6654H11.667V9.9987H13.3337V8.33203H11.667V6.66536H13.3337V8.33203H15.0003V9.9987Z",
    fill: "#6C7275"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZipCodeIcon);
export default __webpack_public_path__ + "static/media/zipCodeIcon.e173b350fe64ccc4fcfe5650180022e3.svg";
export { ForwardRef as ReactComponent };